import { UploadTexts } from '../../../language/Texts';
import { GeneralAttributes } from '../../../models/GeneralAttributes';
import { RequestPaths } from '../../../models/RequestPaths';
import BoxComponent from '../../BoxComponent/BoxComponent';

const ConexoUploadKrohne = ({ manufacturer, setConexoResponse, setLoading, loading }) => {
    const url = RequestPaths.saveInConexoPathKrohne

    return (
        <>
            {manufacturer === GeneralAttributes.krohne &&
                <BoxComponent
                    boxTitle={UploadTexts.datamatrixOrIdLink}
                    setConexoResponse={setConexoResponse}
                    inputType='text'
                    placeholder={UploadTexts.inputIdLink}
                    buttonTex={UploadTexts.saveInConexo}
                    setLoading={setLoading}
                    loading={loading}
                    requestUrl={url}
                    isManufacturerKrohne={true}
                />
            }
        </>
    )
}

export default ConexoUploadKrohne